<template>
  <div>
    <v-tooltip bottom v-if="canCreateHere">
      <template v-slot:activator="{ on }">
        <v-icon
          medium
          class="mr-2"
          v-on="on"
          @click.stop="copyItem(item)"
          data-cy="copy"
        >
          content_copy</v-icon
        >
      </template>
      <span>{{ $t("operatingInstructions.category.copy") }}</span>
    </v-tooltip>
    <v-tooltip bottom v-if="!isReadOnlyUser">
      <template v-slot:activator="{ on }">
        <v-icon
          medium
          class="mr-2"
          v-on="on"
          @click.stop="editItem(item)"
          data-cy="edit"
        >
          edit</v-icon
        >
      </template>
      <span>{{ $t("operatingInstructions.category.edit") }}</span>
    </v-tooltip>
    <v-tooltip bottom v-if="canDeleteHere">
      <template v-slot:activator="{ on }">
        <v-icon
          medium
          class="mr-2"
          v-on="on"
          @click.stop="openDeleteDialog(item)"
          data-cy="delete"
        >
          delete</v-icon
        >
      </template>
      <span>{{ $t("operatingInstructions.category.delete") }}</span>
    </v-tooltip>
    <deleteDialog
      @triggerDelete="deleteItem"
      :item="item"
      :deleteDialog="deleteDialog"
    />
  </div>
</template>

<script>
import deleteDialog from "../../../_utils/dataTableHelpers/actions/deleteDialog.vue";
export default {
  props: ["item"],
  components: {
    deleteDialog,
  },
  data: () => ({
    deleteDialog: {
      open: false,
      title: "operatingInstructions.category.delete",
      description: "",
    },
  }),
  methods: {
    editItem(item) {
      this.$router.push({
        name: "instructionCategoryForm",
        params: { id: item.id, mode: "edit" },
      });
    },
    copyItem(item) {
      this.$router.push({
        name: "instructionCategoryForm",
        params: { id: item.id, mode: "copy" },
      });
    },
    openDeleteDialog(item) {
      this.deleteDialog.open = true;
      this.deleteDialog.description = this.$t(
        "operatingInstructions.category.deleteLong",
        {
          name: item.name,
        }
      );
    },
    deleteItem(item) {
      this.$store.dispatch("deleteInstructionCategory", item).then(() => {
        this.reloadDataFunc();
        this.deleteDialog.open = false;
      });
    },
    reloadDataFunc() {
      this.$emit("reloadData");
    },
  },
};
</script>
